import { Upload } from "lucide-react";

/** Full-tile drop affordance while dragging files over Media / Documents widgets. */
export function EntityFileDropOverlay({ label }: { label: string }) {
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-primary/10 backdrop-blur-sm rounded-2xl pointer-events-none">
      <div className="flex flex-col items-center gap-2 text-primary">
        <Upload className="size-8" />
        <p className="text-sm font-medium">{label}</p>
      </div>
    </div>
  );
}
